import React from 'react';
import PropTypes from 'prop-types';
import { css } from '@emotion/react';
import styled from '@emotion/styled';
import MUIAvatar from '@mui/material/Avatar';
import Initial from '../Icons/Initial';

const BaseAvatar = ({ ...properties }) => <MUIAvatar {...properties} />;

BaseAvatar.propTypes = {
  src: PropTypes.string,
};

BaseAvatar.defaultProps = {
  src: undefined,
};

const StyledAvatar = styled(BaseAvatar)`
  && {
    ${({ border, size }) => css`
      width: ${size}px;
      height: ${size}px;
      font-size: ${size - (size / 6)}px;
      ${border && css`
        border: solid var(--white) ${border}px;
      `}
    `}
    color: var(--white);
  }
  /* stylelint-disable-next-line selector-type-no-unknown */
  progressive-img {
    ${({ size }) => css`
      width: ${size}px;
      height: ${size}px;
      --placeholder-filter: blur(${Math.floor(size / 24) + 1}px) saturate(1.2);
    `}
  }
`;

const Avatar = ({
  name,
  image,
  size,
  ...properties
}) => {
  const initial = name?.toString().charAt(0).toLowerCase() || 'f';

  return (
    <StyledAvatar
      size={size}
      {...properties}
    >
      {image || (
        <Initial
          size={size}
          letter={initial}
        />
      )}
    </StyledAvatar>
  );
};

Avatar.propTypes = {
  size: PropTypes.number,
  border: PropTypes.number,
  name: PropTypes.string,
  image: PropTypes.node,
};

Avatar.defaultProps = {
  name: undefined,
  image: undefined,
  size: 24,
  border: 0,
};

export {
  BaseAvatar as default,
  Avatar,
};
